/**
 banner data store
 */

import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export const sample = {
    namespaced: true,
    state: {
        testVar1:"I am test var 1",
        testVar2:"I am test var 2",
    },
    mutations: {
        setTest1(state, payload) {
            state.testVar1= payload
        },
        setTest2(state, payload) {
            state.testVar2= payload
        }
    },
    getters: {
        testGetter1: state => {
            return `from getter:${state.testVar1}`;
        },
        testGetter2: state => {
            return `from getter:${state.testVar2}`;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/sample.js